/**
 * @file: EntryWarehouse.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 业务数据管理中心-入库管理-采购凭证
 */
import request from '@/utils/request'

/**
 * 添加采购凭证信息(qiuyanping)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehouseAdd(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/add',
    method: 'post',
    data
  })
}

/**
 * 批量删除 采购凭证 信息(cme)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehouseBatchDelete(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/batch/delete',
    method: 'post',
    data
  })
}

/**
 * 删除采购凭证信息(cme)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehouseDelete(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/delete',
    method: 'post',
    data
  })
}

/**
 * 获取 采购凭证 图片信息（凭证照片）(cme)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehouseFileGet(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/file/get',
    method: 'post',
    data
  })
}

/**
 * 查看采购凭证详情(qiuyanping)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehouseGet(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/get',
    method: 'post',
    data
  })
}

/**
 * 获取 采购凭证 列表(cme)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehouseListGet(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/list/get',
    method: 'post',
    data
  })
}

/**
 * 入库价格变动分析-入库价格变动统计（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehousePriceBigdataInfoGet(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/price/bigdata/info/get',
    method: 'post',
    data
  })
}

/**
 * 入库价格变动分析-入库报表全部导出（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehousePriceBigdataListExport(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/price/bigdata/list/export',
    method: 'post',
    data
  })
}

/**
 * 入库价格变动分析-入库报表（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehousePriceBigdataListGet(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/price/bigdata/list/get',
    method: 'post',
    data
  })
}

/**
 * 入库价格变动分析-入库报表部分导出（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehousePriceBigdataListOptionExport(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/price/bigdata/list/option/export',
    method: 'post',
    data
  })
}

/**
 * 更新采购凭证信息(qiuyanping)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function entryWarehouseUpdate(data) {
  return request({
    type: 'biz',
    url: 'entry/warehouse/update',
    method: 'post',
    data
  })
}

/**
 * 业务数据分析-食安大数据分析-入库分析-顶部统计分析(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierBatchAnalyseHeadGet(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/analyse/head/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据分析-食安大数据分析-入库分析-入库报表-全部导出(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierBatchAnalysePageAllExport(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/analyse/page/all/export',
    method: 'post',
    data
  })
}

/**
 * 业务数据分析-食安大数据分析-入库分析-入库报表-分页(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierBatchAnalysePageList(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/analyse/page/list',
    method: 'post',
    data
  })
}

/**
 * 业务数据分析-食安大数据分析-入库分析-入库报表-选择导出(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierBatchAnalysePageOptionExport(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/analyse/page/option/export',
    method: 'post',
    data
  })
}

/**
 * 获取供应商对应的 采购凭证 凭证号 列表信息(Liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function supplierBatchNumberListGet(data) {
  return request({
    type: 'biz',
    url: 'supplier/batch/number/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/EntryWarehouse.js